import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IDisabilityInitialState} from "../types";
import {IEntityWithIDTranslations} from "../../../../../../../types";
import {GetDeleteDisability, GetDisability} from "../store/thunk";

const initialState: IDisabilityInitialState = {
    disability: [],
    isDisabilityRestore: false,
    selectedDisabilityIDs:[],
    disabilityRestore:[],
    isLoadingDisability:true,
    filteredDisability:[]
}

const disabilityGroupSlice = createSlice({
    name: "disabilityGroup",
    initialState,
    reducers: {
        setDisability: (state, action: PayloadAction<{data:IEntityWithIDTranslations[],defaultLanguage:string}>) => {
            const {data,defaultLanguage} = action.payload;
            state.disability= data
            state.filteredDisability =data.flatMap(
                (data) => {
                    return data.translations
                        .filter((elem) => elem.slug === defaultLanguage)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name || "Unknown Name",

                        }));
                }
            );
        },
        deletedDisability: (state, action: PayloadAction<number>) => {
            state.disability= state.disability.filter((elem) => elem.id !== action.payload);
        },
        updateDisability: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.disability = state.disability.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setDisabilityRestore:(state, action) => {
            state.disabilityRestore = action.payload;
        },
        setIsDisabilityRestore:(state)=>{

            state.isDisabilityRestore =!state.isDisabilityRestore;
        },
        deletedRestoreDisability:(state,action)=>{
            state.disabilityRestore = state.disabilityRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedDisabilityIDs: (state, action) => {
            state.selectedDisabilityIDs=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetDisability.pending, (state) => {
                state.isLoadingDisability = true;
            })
            .addCase(GetDisability.fulfilled, (state) => {
                state.isLoadingDisability = false;
            })
            .addCase(GetDisability.rejected, (state) => {
                state.isLoadingDisability = false;
            })
            .addCase(GetDeleteDisability.pending, (state) => {
                state.isLoadingDisability = true;
            })
            .addCase(GetDeleteDisability.fulfilled, (state) => {
                state.isLoadingDisability = false;
            })
            .addCase(GetDeleteDisability.rejected, (state) => {
                state.isLoadingDisability = false;
            });
    },
})

export const{
    setSelectedDisabilityIDs,
    deletedRestoreDisability,
    setIsDisabilityRestore,
    setDisabilityRestore,
    deletedDisability,
    updateDisability,
    setDisability
}=disabilityGroupSlice.actions;

export default disabilityGroupSlice